import { IS_CI, IS_STAGING } from '@dtx-company/true-common/src/constants/env'
import { SET_ACCESS_TOKEN_COOKIE_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { logger } from '@dtx-company/logger'

export async function setAccessTokenCookie(accessToken: string): Promise<void> {
  try {
    const res = await fetch(SET_ACCESS_TOKEN_COOKIE_ENDPOINT, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({ accessToken })
    })
    if (!res.ok) {
      await logger.logFetchError(res, { technicalArea: 'authentication' })
    }

    if (IS_STAGING) {
      /* 
      - extra calls to set an access token cookie with local dev + review apps domains
      - required for flows like SSO where no redirect to localhost / review app URL is not possible
      - means that any prior local or review app login will be overwritten by staging login 
      */
      await fetch(SET_ACCESS_TOKEN_COOKIE_ENDPOINT, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({ accessToken, domain: 'localhost' })
      })
      await fetch(SET_ACCESS_TOKEN_COOKIE_ENDPOINT, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({ accessToken, domain: '.reviewapps.flowcode.com' })
      })
    }

    //needed for connect rpc calls since they are hitting the staging APIs
    if (IS_CI) {
      await fetch('https://app.stg.flowcode.com/api/auth/set-access-token-cookie', {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({ accessToken })
      })
    }
  } catch (e) {
    logger.logError(e, { technicalArea: 'authentication' })
  }
}
